import * as Constants from "../../../constants";

import {useDispatch} from "react-redux";
import {Dispatch} from "react";
import {setSelectedRecord,} from "../../../redux/slices/viewer-slice";
import {AnyAction} from "@reduxjs/toolkit";

const useRecordListItemSelect = (): { handleSelectRecord: Function } => {
  const dispatch:Dispatch<AnyAction> = useDispatch();

  const handleSelectRecord = (selectedRecord: any): void  => {
    const searchParams = new URLSearchParams(window.location.search);
    searchParams.set(Constants.ID, selectedRecord.id);
    window.history.replaceState(null, '', window.location.pathname + "?" + searchParams.toString());
    dispatch(setSelectedRecord(selectedRecord))

    /*if (isMobile) {
      dispatch(setRecordTool(Constants.DOCUMENT))
    }*/
  }

  return {
    handleSelectRecord
  }
};

export default useRecordListItemSelect;
